var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('lottery',{key:_vm.datekey,staticClass:"lottery",attrs:{"round":_vm.round,"data":_vm.roundParm.data,"res":_vm.roundParm.res,"playTime":_vm.playTime,"length":_vm.length},on:{"scrollStop":_vm.onStop,"speedChange":_vm.onSpeedChange,"playPkAudio":_vm.playPkAudio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }